import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import img1 from '../../assets/events/1.jpeg'
import img2 from '../../assets/events/2.jpeg'
import img3 from '../../assets/events/3.jpeg'
import img4 from '../../assets/events/4.jpeg'
import img5 from '../../assets/events/5.jpeg'
import img6 from '../../assets/events/6.jpeg'
import img7 from '../../assets/events/7.jpeg'
import img8 from '../../assets/events/8.jpeg'
import img9 from '../../assets/events/9.jpeg'
import img10 from '../../assets/events/10.jpeg'
import img11 from '../../assets/events/11.jpeg'
import img12 from '../../assets/events/12.jpeg'
import img13 from '../../assets/events/13.jpeg'
import img14 from '../../assets/events/14.jpeg'
import img15 from '../../assets/events/15.jpeg'
import img16 from '../../assets/events/16.jpeg'
import img17 from '../../assets/events/17.jpeg'
import img18 from '../../assets/events/18.jpeg'
import img19 from '../../assets/events/19.jpeg'
import img20 from '../../assets/events/20.jpeg'
import img21 from '../../assets/events/21.jpeg'
import img22 from '../../assets/events/22.jpeg'
import img23 from '../../assets/events/23.jpeg'
import img24 from '../../assets/events/24.jpeg'
import img25 from '../../assets/events/25.jpeg'
import img26 from '../../assets/events/26.jpeg'
import img27 from '../../assets/events/27.jpeg'
import img28 from '../../assets/events/28.jpeg'
import img29 from '../../assets/events/29.jpeg'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  const sliderImageUrl = [
  //First image url
  {
      url:img1,
      caption: 'Free Demo Course 1'
  },
  {
      url:img2,
      caption: 'Free Demo Course 2'
  },
  {
      url:img3,
      caption: 'Free Demo Course 3'
  },
  {
      url:img4,
      caption: 'Free Demo Course 4'
  },
  {
      url:img5,
      caption: 'Free Demo Course 1'
  },
  {
      url:img6,
      caption: 'Free Demo Course 2'
  },
  {
      url:img7,
      caption: 'Free Demo Course 3'
  },
  {
    url:img8,
    caption: 'Free Demo Course 3'
},
{
    url:img9,
    caption: 'Free Demo Course 3'
},
{
    url:img10,
    caption: 'Free Demo Course 3'
},
{
    url:img11,
    caption: 'Free Demo Course 1'
},
{
    url:img12,
    caption: 'Free Demo Course 2'
},
{
    url:img13,
    caption: 'Free Demo Course 3'
},
{
    url:img14,
    caption: 'Free Demo Course 4'
},
{
    url:img15,
    caption: 'Free Demo Course 1'
},
{
    url:img16,
    caption: 'Free Demo Course 2'
},
{
    url:img17,
    caption: 'Free Demo Course 3'
},
{
  url:img18,
  caption: 'Free Demo Course 3'
},
{
  url:img19,
  caption: 'Free Demo Course 3'
},
{
  url:img20,
  caption: 'Free Demo Course 3'
},
{
    url:img21,
    caption: 'Free Demo Course 1'
},
{
    url:img22,
    caption: 'Free Demo Course 2'
},
{
    url:img23,
    caption: 'Free Demo Course 3'
},
{
    url:img24,
    caption: 'Free Demo Course 4'
},
{
    url:img25,
    caption: 'Free Demo Course 1'
},
{
    url:img26,
    caption: 'Free Demo Course 2'
},
{
    url:img27,
    caption: 'Free Demo Course 3'
},
{
  url:img28,
  caption: 'Free Demo Course 3'
},
{
  url:img29,
  caption: 'Free Demo Course 3'
},
 
];

const Eventsec = () => {
  return (
        <div>
                
                <div className="carousel-image">
                   
                     <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} 
                            >
                            {sliderImageUrl.map((imageUrl, index) => {
                              return (
                                <div className="slider" key={index}>
                                  
                                  <img src={imageUrl.url} alt="movie" />
                                  
                                </div>
                              );
                            })}
                            
                            
                            </Carousel>

                </div>
            </div>
  )
}

export default Eventsec